import shape from "../../assets/img/shapes/right-shape-01.webp";


const RightShape01 = () => {

    return (
        <div className="rmdr-right-shape-01">
            <img src={shape} alt="rmdr-right-shape-01" loading="lazy" width={131} height={232} />
        </div>
    )

}

export default RightShape01;
